import { render, staticRenderFns } from "./project_not_found.vue?vue&type=template&id=5e68865d&scoped=true&"
import script from "./project_not_found.vue?vue&type=script&lang=js&"
export * from "./project_not_found.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e68865d",
  null
  
)

export default component.exports